import { Values } from '@lib/interfaces/form';
import UserFieldNames from '@lib/enums/fieldNames/userFieldNames';
import { getRolesOptions } from '@lib/utils/roles';
import { UserAssignationType } from 'components/UserForm/utils/enums';

export default function getEmptyDefaultValues(): Values {
  return {
    id: null,
    deactivatedAt: null,
    'login-credentials': null,
    separator: null,
    'separator-empty': null,
    'personal-info': null,
    [UserFieldNames.Role]: getRolesOptions()[0],
    [`${UserFieldNames.Assignations}-title`]: null,
    [UserFieldNames.Username]: null,
    [UserFieldNames.Password]: null,
    [UserFieldNames.GenerateNewPassword]: null,
    [UserFieldNames.Email]: null,
    [`${UserFieldNames.Email}-copy`]: null,
    [UserFieldNames.FirstName]: null,
    [UserFieldNames.LastName]: null,
    [UserFieldNames.PersonalId]: null,
    [UserFieldNames.PhoneNumber]: null,
    [UserFieldNames.SiteMemberships]: [],
    [UserFieldNames.Team]: null,
    [`${UserFieldNames.Team}-warning`]: null,
    [UserFieldNames.AssignationType]: { value: UserAssignationType.Sector },
  };
}
